/* 🤖 this file was generated by svg-to-ts */
export const iccIconArrowForward: {
  name: 'arrow_forward';
  data: string;
} = {
  name: 'arrow_forward',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" fill="currentColor"/></svg>`
};
